/* @flow */

import { rem } from 'polished';

import { successColor, textColor } from '@e180/ui/lib/token/color';
import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    extend: antialiasing,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    padding: [4, 12],

    backgroundColor: successColor,
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit',
    color: textColor,

    fontSize: rem(13, baseFontSize),
    lineHeight: 15 / 13,
  },
};
